import React, { useEffect, useContext } from 'react';
import Button from '../../../../../components/UI/Button';
import Card from '../../UI/Card';
import CheckListItem from '../../../../../components/UI/CheckListItem';
import css from './denied.module.scss';
import { getPlanNameText, getSavingsReward } from '../../helpers';
import LegalText from '../../UI/LegalText';
import { AnalyticsContext } from '../../../../../ModularReduxAnalytics';

export default function Denied({ planName, moveToFundWallet }) {
  const { analytics } = useContext(AnalyticsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.page('Registration', 'Credit Application Denied');
  }, []);

  const planNameText = getPlanNameText(planName);
  const savingsReward = getSavingsReward(planName);
  return (
    <div className={css.deniedContainer}>
      <img alt="Card" src="/static/card.svg" />
      <h1>Credit application denied</h1>
      <div className={css.subheadingContainer}>
        <h2 className={css.subheading}>
          Your application did not meet the qualifications for the Family Cash
          Card. You can reapply after 30 days. Our partner bank, First National
          Bank of Omaha (FNBO®), will reach out via email with more information.
        </h2>
        <Card>
          <h2>
            {`In the meantime, you have a 1-month free trial with ${planNameText}.`}
          </h2>
          <CheckListItem>
            <p>Up to 5 debit cards for your kids.</p>
          </CheckListItem>
          <CheckListItem>
            <p>
              Educational app to send money to your kids, set up chores, set
              savings goals, and more.
            </p>
          </CheckListItem>
          <CheckListItem>
            <p>{`${savingsReward}% Savings Reward.**`}</p>
          </CheckListItem>
          <Button
            text="Continue"
            onClick={() => {
              analytics.trackEvent('Credit Action', {
                eventProps: {
                  type: 'Continue',
                  page: 'Credit Application Denied'
                }
              });
              moveToFundWallet();
            }}
          />
        </Card>
      </div>
      <LegalText>
        <p>
          **See Greenlight’s Terms of Service for details on earnings limits and
          how to qualify. Subject to change at any time.
        </p>
      </LegalText>
    </div>
  );
}
